
export const isOptionValueInOptions = (options, optionId, optionValueId) => {
  const materialOption = options.find(opt => +opt.id === +optionId);
  return !!materialOption?.values.some(optVal => +optVal.id === +optionValueId);
};

export const getDefaultOptionsData = options => {
  const defaultOptionsList = [];
  let finalSku = '';
  options.forEach(option => {
    const defaultVal = option.default_value
      ? option.values.find(val => +val.id === +option.default_value)
      : option.values[0];
    if (defaultVal) {
      defaultOptionsList.push({
        id: defaultVal.id,
        name: defaultVal.value,
        optionTypeName: option.name,
        optionTypeId: option.id,
        sku: defaultVal.sku,
      });
      finalSku += defaultVal.sku;
    }
  });
  return { defaultOptionsList, finalSku };
};

export const getProductOptionsUrl = ({ options, pickLater, productUrlKey }) => {
  const opts = options
    .map(
      o =>
        `${o.optionTypeName
          .toLowerCase()
          .split(' ')
          .join('-')}=${o.name.toLowerCase().split(' ').join('-')}`
    )
    .filter(Boolean);
  if (pickLater) {
    opts.push('dl=true');
  }
  return `${productUrlKey}?${opts.join('&')}`;
};
